/**
===================================================
Module: frontend.src.components.visualizer.Visualiser.tsx
Description: Main visualizer component for VSLAM data display
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  VisualizerProvider,
  useVisualizer,
} from "../../contexts/VisualizerContext";
import { useNotifications } from "../../hooks/useNotifications";
import LoadingOverlay from "./LoadingOverlay";
import SceneAndControls from "./SceneAndControls";
import KeyframePanel from "./KeyframePanel";
import NotificationSystem from "../NotificationSystem";
import "../../styles/Visualiser.css";

const VisualizerContent: React.FC = () => {
  const { notifications, removeNotification, addError, addSuccess, addInfo } =
    useNotifications();
  const { registerNotifications } = useVisualizer();

  useEffect(() => {
    registerNotifications({ addError, addSuccess, addInfo });
  }, [registerNotifications, addError, addSuccess, addInfo]);

  return (
    <>
      <NotificationSystem
        notifications={notifications}
        onRemove={removeNotification}
      />

      <LoadingOverlay />

      <div className="visualiser-container">
        <SceneAndControls />
        <KeyframePanel />
      </div>
    </>
  );
};

const Visualiser: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();

  if (!sessionId) {
    return (
      <div className="visualiser-container">
        <div className="error-message">No session ID provided</div>
      </div>
    );
  }

  return (
    <VisualizerProvider sessionId={sessionId}>
      <VisualizerContent />
    </VisualizerProvider>
  );
};

export default Visualiser;
